
import $ from 'jquery';
import plugin from '@core/plugins/lib';
import { onAvailable } from "@core/plugins/lib/selectors";


export const ELEMENT_SELECTOR = '[data-remove-element-classes]';
export const PLUGIN_NAME = 'RemoveElementClasses';


$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--remove-element-classes" */ './plugin.js'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__remove-element-classes/index.js